import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookiesPopupComponent } from '../auth/login/cookies-popup/cookies-popup.component';
import { RuleEngineTestComponent } from './components/rule-engine-test/rule-engine-test.component';

@NgModule({
  declarations: [
    RuleEngineTestComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RuleEngineTestComponent
  ]
})
export class CoreModule { }
